// extracted by mini-css-extract-plugin
export default {"formContainer":"Admintestimonials_formContainer__RRpOZ","testimonialForm":"Admintestimonials_testimonialForm__7to-D","message":"Admintestimonials_message__6E+X6"};